import { Headshot, LookupKeys } from '@ag-common-lib/public-api';
import { CaptionOptions, CaptionPosition } from './template-builder-caption.model';
import { AspectRatio } from './template-builder-aspect-ration.model';
import { ObjectFit } from './template-builder-object-fit.model';
import { VimeoSortingKeys } from 'ag-common-svc/lib/modules/vimeo/vimeo.service';

export enum VideoWidgetMode {
  single = 'single',
  grid = 'grid',
}

export const VideoWidgetModeMap = new Map([
  [VideoWidgetMode.single, 'Single'],
  [VideoWidgetMode.grid, 'Grid'],
]);

export const VIDEO_WIDGET_MODE_LOOKUP = [VideoWidgetMode.single, VideoWidgetMode.grid].map(value => {
  return { [LookupKeys.value]: value, [LookupKeys.description]: VideoWidgetModeMap.get(value) };
});

export enum VideoSource {
  list = 'list',
  folder = 'folder',
  byTags = 'byTags',
}

export const VideoSourceMap = new Map([
  [VideoSource.list, 'From List'],
  [VideoSource.folder, 'From Folder'],
  [VideoSource.byTags, 'By Tags'],
]);

export const VIDEO_SOURCE_LOOKUP = [VideoSource.list, VideoSource.folder, VideoSource.byTags].map(value => {
  return { [LookupKeys.value]: value, [LookupKeys.description]: VideoSourceMap.get(value) };
});

export enum VideoServiceType {
  vimeo = 'vimeo',
  youtube = 'youtube',
}

export const VideoServiceTypeMap = new Map([
  [VideoServiceType.vimeo, 'Vimeo'],
  [VideoServiceType.youtube, 'YouTube'],
]);

export const VIDEO_SERVICE_TYPE_LOOKUP = [VideoServiceType.vimeo /* , VideoServiceType.youtube */].map(value => {
  return { [LookupKeys.value]: value, [LookupKeys.description]: VideoServiceTypeMap.get(value) };
});

export class VideoWidgetItem {
  videoId?: string;
  serviceType: VideoServiceType = VideoServiceType.vimeo;
  title?: string = '';
  description?: string = '';
  headshot?: Headshot;
  autoplay?: boolean = false;
  width?: number;
  height?: number;
}

export enum VideoSortingWithDirectionKeys {
  AlphabeticalAsc = `${VimeoSortingKeys.alphabetical}_asc`,
  AlphabeticalDesc = `${VimeoSortingKeys.alphabetical}_desc`,
  DateAsc = `${VimeoSortingKeys.date}_asc`,
  DateDesc = `${VimeoSortingKeys.date}_desc`,
}

export enum VideoFilterOperatorKeys {
  FilterTag = 'filter_tag',
  FilterTagAllOf = 'filter_tag_all_of',
}

export class VideoWidgetData {
  mode: VideoWidgetMode = VideoWidgetMode.single;
  videoSource: VideoSource = VideoSource.list;
  items: VideoWidgetItem[] = [];
  folder: string = null;
  tags: string[] = [];
  sorting: VideoSortingWithDirectionKeys = VideoSortingWithDirectionKeys.DateAsc;
  filter: VideoFilterOperatorKeys = VideoFilterOperatorKeys.FilterTag;
  gap: number = 8;
  paddingTop: number = 0;
  paddingBottom: number = 0;
  width: number = 100;
  minWidth: number = 128;
  maxHeight: number = null;
  videosPerRow: number = 3;
  rowsPerPage: number = 3;
  objectFit: ObjectFit = ObjectFit.contain; // (issue: letterbox with black bars as in vimeo)
  aspectRation: AspectRatio = AspectRatio.None;
  titleMode: CaptionPosition = CaptionPosition.none;
  titleOptions: CaptionOptions = new CaptionOptions();
  descriptionMode: CaptionPosition = CaptionPosition.none;
  descriptionOptions: CaptionOptions = new CaptionOptions(15);
}
